module.exports = __webpack_public_path__ + "down_pointer.png?a9bfb7715a7d193f5e2731bfc2fbb971";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/down_pointer.png
// module id = 422
// module chunks = 0